<template>
  <div class="agreement-page">
    <!-- カスタムナビゲーション -->
    <div class="nav-bar">
      <div class="nav-back" @click="goBack">
        <van-icon name="arrow-left" size="22" />
        <span>戻る</span>
      </div>
      <div class="nav-title">口座開設協定</div>
      <div class="nav-placeholder"></div>
    </div>

    <!-- ヒーローセクション -->
    <div class="hero-section">
      <div class="hero-icon">🏛</div>
      <h1 class="hero-title">安心の結び</h1>
      <p class="hero-sub">あんしんのむすび</p>
      <div class="hero-divider"></div>
      <p class="hero-caption">アカウント開設規約</p>
   <!--   <div class="hero-badge">最終更新：2026年7月</div> -->
    </div>

    <div class="agreement-content">
      <!-- 第1条 -->
      <div class="clause">
        <div class="clause-header">
          <span class="clause-number">01</span>
          <h2>総則および定義</h2>
        </div>
        <div class="clause-body">
          <ol>
            <li>本規約は、<strong>安心の結び（あんしんのむすび）</strong>（以下「当社」といいます）が運営するプラットフォーム「安心の結び」（以下「本サービス」といいます）の利用に関わる一切の関係に適用されます。</li>
            <li>会員は、アカウント開設の申請または本サービスの利用開始をもって、本規約の全条項を充分に理解し、同意したものとみなされます。</li>
            <li>本サービスは、当社が独自に企画・運営するものであり、他社の提供する同名のサービスや特定の社会福祉サービスとは一切関係がありません。</li>
          </ol>
        </div>
      </div>

      <!-- 第2条 -->
      <div class="clause">
        <div class="clause-header">
          <span class="clause-number">02</span>
          <h2>会員資格</h2>
        </div>
        <div class="clause-body">
          <p>本サービスのアカウント開設を申請できるのは、<span class="highlight">満 28歳以上</span> であり、かつ完全な民事行為能力を有する方に限るものとします。申請者が資格を満たさない場合、または過去に本規約に違反した事実がある場合、当社はその理由を開示することなく申請を拒否できるものとします。</p>
        </div>
      </div>

      <!-- 第3条 -->
      <div class="clause">
        <div class="clause-header">
          <span class="clause-number">03</span>
          <h2>アカウントの開設と管理</h2>
        </div>
        <div class="clause-body">
          <ol>
            <li>会員は、真実かつ正確な情報を提供してアカウント開設を行うものとします。</li>
            <li>アカウントは会員本人のみが利用できるものとし、第三者への譲渡、貸与、売買、または共用を固く禁じます。</li>
            <li>会員は自己の責任においてパスワードを厳重に管理するものとし、管理不十分による損害について当社は一切の責任を負いません。</li>
          </ol>
        </div>
      </div>

      <!-- 第4条 -->
      <div class="clause">
        <div class="clause-header">
          <span class="clause-number">04</span>
          <h2>個人情報の保護</h2>
        </div>
        <div class="clause-body">
          <p>当社は、関連法令およびプライバシーポリシーに基づき会員の個人情報を適切に管理します。法令に基づく場合または本人の同意がある場合を除き、個人情報を第三者に開示することはありません。</p>
        </div>
      </div>

      <!-- 第5条 -->
      <div class="clause">
        <div class="clause-header">
          <span class="clause-number">05</span>
          <h2>サービス内容および運営権限</h2>
        </div>
        <div class="clause-body">
          <ul>
            <li>
              <span class="label">サービス範囲</span>
              <p>会員は、<span class="highlight">安心カード（あんしんカード）</span>の認証完了後、その会員ランクに応じ、イベント申込、ポイント交換、専用メッセージ機能、および通知の受信等のサービスを利用できるものとします。</p>
            </li>
            <li>
              <span class="label">サービスの最適化</span>
              <p>当社は、ユーザー体験の向上およびセキュリティ強化を目的として、事前の予告なくサービス内容の一部を最適化、アップグレード、または調整する権利を有します。</p>
            </li>
            <li>
              <span class="label">サービスの中断と免責</span>
              <p>以下の各号のいずれかに該当する場合、当社は会員への事前の通知なく、本サービスの全部または一部を一時的に停止または中断することができるものとし、これに起因する損害について一切の責任を負わないものとします。</p>
              <ul class="sub-list">
                <li>システムの定期保守、点検、または更新を行う場合。</li>
                <li>天災、停電、通信事業者の回線障害等の不可抗力により運営が困難な場合。</li>
                <li>サイバー攻撃やセキュリティ上の脅威から会員のプライバシーを保護する緊急の必要がある場合。</li>
                <li>法令の改正や行政機関の命令に基づく場合。</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>

      <!-- 第6条 -->
      <div class="clause">
        <div class="clause-header">
          <span class="clause-number">06</span>
          <h2>禁止事項</h2>
        </div>
        <div class="clause-body">
          <p>会員は、本サービスの利用にあたり以下の行為を行ってはなりません。</p>
          <ul class="prohibited-list">
            <li>✕ 虚偽情報の提供、または他者へのなりすまし。</li>
            <li>✕ 本サービスの運営を妨害する行為。</li>
            <li>✕ 他の会員に対する嫌がらせ、誹謗中傷、または公序良俗に反する行為。</li>
            <li>✕ 当社の外部サイトにおいて、本サービスに関する虚偽または誤解を招く言論を流布する行為。</li>
          </ul>
        </div>
      </div>

      <!-- 第7条 -->
      <div class="clause">
        <div class="clause-header">
          <span class="clause-number">07</span>
          <h2>利用停止および解除</h2>
        </div>
        <div class="clause-body">
          <p>会員が本規約に違反した場合、当社は事前の通知なく直ちにアカウントを停止または解除できるものとします。会員が自らアカウントを解約した場合でも、既にお支払いいただいた費用の返金には一切応じかねます。</p>
        </div>
      </div>

      <!-- 第8条 -->
      <div class="clause">
        <div class="clause-header">
          <span class="clause-number">08</span>
          <h2>免責事項および安全確保</h2>
        </div>
        <div class="clause-body">
          <ol>
            <li>会員は、自己の責任において本サービスを利用するものとします。</li>
            <li>会員による暴力、脅迫、恐喝行為が認められた場合、当社は直ちに会員資格を剥奪し、法的措置を講じる権利を留保します。</li>
            <li>当社は、通常会員および <span class="highlight">「安心カード（あんしんカード）」</span> 会員に対し、円滑なサービス提供のための必要なサポートを行います。</li>
          </ol>
        </div>
      </div>

      <!-- 第9条 -->
      <div class="clause card-clause">
        <div class="clause-header">
          <span class="clause-number">09</span>
          <h2>安心カード <span class="card-sub">あんしんカード</span></h2>
        </div>
        <div class="clause-body">
          <div class="card-feature">
            <div class="card-icon">💳</div>
            <div class="card-info">
              <ol>
                <li><span class="highlight">「安心カード（あんしんカード）」</span> は、所定の本人確認完了後に発行される永続的に有効な電子認証です。</li>
                <li>実体カードの発行はなく、会員はアカウント内のマイページにて認証ステータスを確認できるものとします。</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <!-- 第10条 - 認証セクション（文字サイズ拡大） -->
      <div class="clause security-clause">
        <div class="clause-header">
          <span class="clause-number">10</span>
          <h2>会員認証および安全管理システム</h2>
        </div>
        <div class="clause-body">
          <p class="security-intro">本サービスは、会員の安全性と実在性を担保するため、独自の「<span class="highlight">3段階認証制度</span>」を採用しています。本プロセスは「簡潔・守秘・親和」の理念に基づき、完了した会員には認証バッジが付与されます。</p>

          <!-- 3段階認証 -->
          <div class="step-section">
            <div class="step-title-large">3段階認証のステップ</div>
            <div class="step-grid-large">
              <div class="step-card-large">
                <div class="step-number-large">1</div>
                <div class="step-content-large">
                  <div class="step-name-large">本人確認</div>
                  <div class="step-desc-large">スマートフォンを通じて本人確認</div>
                </div>
              </div>
              <div class="step-card-large">
                <div class="step-number-large">2</div>
                <div class="step-content-large">
                  <div class="step-name-large">信頼会員認証</div>
                  <div class="step-desc-large">安全な決済手段で実在性確認</div>
                </div>
              </div>
              <div class="step-card-large">
                <div class="step-number-large">3</div>
                <div class="step-content-large">
                  <div class="step-name-large">セキュリティ認証</div>
                  <div class="step-desc-large">安全ガイドライン同意後、自動チェック</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 安全へのコミットメント -->
          <div class="security-commitment-large">
            <div class="commitment-header-large">
              <span class="shield-icon-large">⚠️</span>
              <span class="commitment-title-large">安全へのコミットメント</span>
            </div>
            <p class="commitment-text-large">銀行口座の取引明細や給与明細の提出を求めることはありません。</p>
          </div>

          <!-- 禁止行為 -->
          <div class="security-guarantee-large">
            <div class="guarantee-title-large">当社は以下の行為を一切行いません</div>
            <ul class="guarantee-list-large">
              <li>
                <span class="icon-large">🚫</span>
                <span>不審なアプリのダウンロードや遠隔操作ソフトのインストールを要求する行為。</span>
              </li>
              <li>
                <span class="icon-large">🚫</span>
                <span>銀行パスワード、SMS認証コード、ワンタイムパスワード（OTP）の提供を求める行為。</span>
              </li>
              <li>
                <span class="icon-large">🚫</span>
                <span>外部リンクを通じた操作を要求する行為（全ての手続きは本サービス内または公式アカウント内で行われます）。</span>
              </li>
            </ul>
          </div>

         <!-- <div class="badge-confirm-large">
           <span class="check-icon-large">✅</span>
            <span>認証完了後、マイページに認証バッジが表示されます</span>
          </div> -->
        </div>
      </div>

      <!-- フッター -->
      <div class="page-footer">
        <div class="footer-line"></div>
        <div class="footer-content">
          <span class="footer-icon">🏛</span>
          <span class="footer-name">安心の結び</span>
          <span class="footer-divider">·</span>
   <!--       <span class="footer-date">制定 2026年7月</span> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AgreementPage',
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.agreement-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #faf6f9 0%, #ffffff 40%);
}

// ナビゲーションバー
.nav-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: linear-gradient(135deg, #7e5678 0%, #9b6f94 100%);
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 4px 20px rgba(126, 86, 120, 0.25);

  .nav-back {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 8px;
    transition: background 0.2s;

    &:hover {
      background: rgba(255, 255, 255, 0.15);
    }

    .van-icon {
      color: #fff;
    }
  }

  .nav-title {
    color: #fff;
    font-size: 19px;
    font-weight: 600;
    letter-spacing: 1px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .nav-placeholder {
    width: 80px;
  }
}

// ヒーローセクション
.hero-section {
  text-align: center;
  padding: 40px 20px 32px;
  background: linear-gradient(180deg, #faf6f9 0%, #ffffff 100%);
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
    max-width: 400px;
    height: 2px;
    background: linear-gradient(90deg, transparent, #d9c6d6, transparent);
  }

  .hero-icon {
    font-size: 52px;
    display: block;
    margin-bottom: 8px;
  }

  .hero-title {
    font-size: 38px;
    font-weight: 700;
    color: #7e5678;
    letter-spacing: 4px;
    margin: 0 0 4px;
    background: linear-gradient(135deg, #7e5678 0%, #a87a9e 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .hero-sub {
    font-size: 18px;
    color: #9b7b95;
    letter-spacing: 8px;
    margin: 4px 0 12px;
  }

  .hero-divider {
    width: 60px;
    height: 3px;
    background: linear-gradient(90deg, #d9c6d6, #7e5678);
    margin: 12px auto;
    border-radius: 2px;
  }

  .hero-caption {
    font-size: 20px;
    font-weight: 500;
    color: #5e3f5a;
    letter-spacing: 2px;
    margin: 8px 0 12px;
  }

  .hero-badge {
    display: inline-block;
    background: #f4edf2;
    color: #9b7b95;
    font-size: 13px;
    padding: 4px 18px;
    border-radius: 30px;
    letter-spacing: 0.5px;
  }
}

// コンテンツ
.agreement-content {
  padding: 24px 20px 40px;
  max-width: 900px;
  margin: 0 auto;
}

// 各条項
.clause {
  background: #ffffff;
  border-radius: 20px;
  padding: 24px 28px 20px;
  margin-top: 24px;
  box-shadow: 0 2px 16px rgba(126, 86, 120, 0.06);
  border: 1px solid #f0e8ee;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 24px rgba(126, 86, 120, 0.10);
    transform: translateY(-2px);
  }

  .clause-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f5eef3;

    .clause-number {
      font-size: 16px;
      font-weight: 700;
      color: #ffffff;
      background: linear-gradient(135deg, #7e5678, #a87a9e);
      padding: 2px 14px;
      border-radius: 30px;
      line-height: 30px;
      letter-spacing: 0.5px;
      flex-shrink: 0;
    }

    h2 {
      font-size: 21px;
      font-weight: 700;
      color: #3c2a3a;
      margin: 0;

      .card-sub {
        font-size: 15px;
        font-weight: 400;
        color: #9b7b95;
        margin-left: 6px;
      }
    }
  }

  .clause-body {
    p,
    li {
      font-size: 17px;
      color: #3c353b;
      line-height: 2;
      margin-bottom: 8px;
    }

    ol,
    ul {
      padding-left: 24px;
      margin: 4px 0;
    }

    li {
      margin-bottom: 6px;
    }

    .sub-list {
      padding-left: 28px;
      margin-top: 4px;
      list-style-type: circle;

      li {
        font-size: 16px;
        color: #5a4a57;
      }
    }

    .highlight {
      color: #7e5678;
      font-weight: 700;
      padding: 0 4px;
    }

    .label {
      display: inline-block;
      font-weight: 700;
      color: #5e3f5a;
      font-size: 16px;
      margin-bottom: 2px;
    }
  }
}

// 禁止リスト
.prohibited-list {
  list-style: none;
  padding-left: 0 !important;

  li {
    padding: 6px 0 6px 8px;
    font-size: 17px;
    color: #4a3a47;
    border-bottom: 1px solid #f5eef3;

    &:last-child {
      border-bottom: none;
    }
  }
}

// カード条項
.card-clause {
  background: linear-gradient(135deg, #faf6f9, #f5edf2);
  border: 1px solid #e8dce4;

  .card-feature {
    display: flex;
    align-items: flex-start;
    gap: 16px;

    .card-icon {
      font-size: 36px;
      flex-shrink: 0;
    }

    .card-info {
      flex: 1;

      ol {
        padding-left: 20px;
        margin: 0;
      }

      li {
        font-size: 17px;
        line-height: 2;
      }
    }
  }
}

// ============================================
// 第10条 セキュリティ認証（文字サイズ拡大版）
// ============================================
.security-clause {
  background: linear-gradient(135deg, #f8f3f7, #ffffff);
  border: 1px solid #e8dce4;

  .security-intro {
    font-size: 18px !important;
    line-height: 2 !important;
    margin-bottom: 16px !important;
  }
}

.step-section {
  margin: 20px 0 16px;

  .step-title-large {
    font-size: 20px;
    font-weight: 700;
    color: #5e3f5a;
    margin-bottom: 16px;
    letter-spacing: 1px;
  }

  .step-grid-large {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 14px;

    .step-card-large {
      background: #fff;
      border-radius: 16px;
      padding: 18px 20px;
      display: flex;
      align-items: center;
      gap: 16px;
      border: 1.5px solid #e8dce4;
      box-shadow: 0 2px 8px rgba(126, 86, 120, 0.04);

      .step-number-large {
        background: linear-gradient(135deg, #7e5678, #a87a9e);
        color: #fff;
        width: 42px;
        height: 42px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 19px;
        font-weight: 700;
        flex-shrink: 0;
      }

      .step-content-large {
        flex: 1;

        .step-name-large {
          font-size: 18px;
          font-weight: 700;
          color: #3c2a3a;
          margin-bottom: 2px;
        }

        .step-desc-large {
          font-size: 16px;
          color: #7a6a77;
          line-height: 1.5;
        }
      }
    }
  }
}

// 安全コミットメント（拡大）
.security-commitment-large {
  background: linear-gradient(135deg, #f8eff5, #f3eaf0);
  border-radius: 16px;
  padding: 18px 22px;
  margin: 18px 0;
  border-left: 4px solid #7e5678;

  .commitment-header-large {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 6px;

    .shield-icon-large {
      font-size: 24px;
    }

    .commitment-title-large {
      font-size: 19px;
      font-weight: 700;
      color: #5e3f5a;
    }
  }

  .commitment-text-large {
    font-size: 18px;
    color: #3c2a3a;
    margin: 4px 0 0;
    padding-left: 34px;
    line-height: 1.8;
    font-weight: 500;
  }
}

// 禁止行為（拡大）
.security-guarantee-large {
  margin: 18px 0 14px;

  .guarantee-title-large {
    font-size: 19px;
    font-weight: 700;
    color: #5e3f5a;
    margin-bottom: 12px;
    letter-spacing: 0.5px;
  }

  .guarantee-list-large {
    list-style: none;
    padding-left: 0 !important;

    li {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      padding: 8px 0;
      font-size: 17px;
      line-height: 1.9;
      color: #3c2a3a;
      border-bottom: 1px solid #f5eef3;

      &:last-child {
        border-bottom: none;
      }

      .icon-large {
        font-size: 20px;
        flex-shrink: 0;
        margin-top: 2px;
      }
    }
  }
}

// バッジ確認（拡大）
.badge-confirm-large {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: linear-gradient(135deg, #efe8ec, #e8dee4);
  border-radius: 40px;
  padding: 12px 24px;
  font-size: 17px;
  font-weight: 500;
  color: #4b3647;
  margin-top: 14px;

  .check-icon-large {
    font-size: 22px;
  }
}

// フッター
.page-footer {
  margin-top: 48px;
  padding-top: 20px;

  .footer-line {
    height: 2px;
    background: linear-gradient(90deg, transparent, #d9c6d6, transparent);
    margin-bottom: 16px;
  }

  .footer-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-size: 16px;
    color: #9b7b95;

    .footer-icon {
      font-size: 20px;
    }

    .footer-name {
      font-weight: 500;
      color: #7e5678;
    }

    .footer-divider {
      color: #d9c6d6;
    }

    .footer-date {
      color: #b5a3b0;
    }
  }
}

// モバイル
@media (max-width: 640px) {
  .nav-bar {
    padding: 12px 16px;

    .nav-title {
      font-size: 17px;
    }

    .nav-back {
      font-size: 14px;
    }
  }

  .hero-section {
    padding: 28px 16px 24px;

    .hero-icon {
      font-size: 40px;
    }

    .hero-title {
      font-size: 30px;
      letter-spacing: 2px;
    }

    .hero-sub {
      font-size: 15px;
      letter-spacing: 4px;
    }

    .hero-caption {
      font-size: 17px;
    }
  }

  .agreement-content {
    padding: 16px 14px 30px;
  }

  .clause {
    padding: 18px 16px 16px;
    margin-top: 18px;

    .clause-header {
      .clause-number {
        font-size: 14px;
        line-height: 26px;
        padding: 0 12px;
      }

      h2 {
        font-size: 18px;
      }
    }

    .clause-body {
      p,
      li {
        font-size: 15px;
        line-height: 1.9;
      }

      .sub-list li {
        font-size: 14px;
      }
    }
  }

  .card-clause .card-feature {
    flex-direction: column;
    align-items: stretch;

    .card-icon {
      font-size: 30px;
    }
  }

  // 第10条 モバイル対応
  .security-clause {
    .security-intro {
      font-size: 16px !important;
    }
  }

  .step-section {
    .step-title-large {
      font-size: 18px;
    }

    .step-grid-large {
      grid-template-columns: 1fr;

      .step-card-large {
        padding: 14px 16px;

        .step-number-large {
          width: 36px;
          height: 36px;
          font-size: 16px;
        }

        .step-content-large {
          .step-name-large {
            font-size: 16px;
          }

          .step-desc-large {
            font-size: 14px;
          }
        }
      }
    }
  }

  .security-commitment-large {
    padding: 14px 16px;

    .commitment-header-large {
      .commitment-title-large {
        font-size: 17px;
      }
    }

    .commitment-text-large {
      font-size: 16px;
      padding-left: 0;
    }
  }

  .security-guarantee-large {
    .guarantee-title-large {
      font-size: 17px;
    }

    .guarantee-list-large li {
      font-size: 15px;
      padding: 6px 0;
    }
  }

  .badge-confirm-large {
    font-size: 15px;
    padding: 10px 18px;
  }

  .page-footer .footer-content {
    font-size: 14px;
  }
}
</style>